import * as Init from '../init.js';
import { CLAPI } from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as SPOOL from './spool3.res.js'
import * as COMMON from './common.res.js'

function getMclassName(inData) {
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), SPOOL.SPOOLCLASS.length)
    return SPOOL.SPOOLCLASS[mclassindex]
}

function setMclassCtrl(curChart, inData, region) {
    const chartName = 'mclassCtrl'
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: SPOOL.CHART_SPOOL_MCLASS,
        rectMain: curRect

    }
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), SPOOL.SPOOLCLASS.length)
    curCfg.config.selectIndex = mclassindex;
    
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, 'mclassindex', result.selectIndex)
            onLoad()
        }
    })
}

function setDateCtrl(curChart, inData, region) {
    const chartName = 'DateCtrl'
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 0,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 4, // Y方向留空
            }
        },
        config: COMMON.CHART_LEFT_DATES,
        rectMain: curRect

    }
    
    const mclassname = getMclassName(inData)
    
    COMMON.initDateCtrl('日期列表')
    
    for (let index = 0; index < inData['dates'].datas.length; index++) {
        // COMMON.incrDateCtrl(index, CLAPI.getData(inData['dates'], 'date', index), 0.0)
        COMMON.incrDateCtrl(index, CLAPI.getData(inData['dates'], 'date', index))
    }

    curCfg.config.selectIndex = Init.getUserInfo(inData.modulename, mclassname + 'dateindex', 0)
    // console.log(leftLayoutCfg.config.selectIndex);
    // const leftchart = 
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, mclassname + 'dateindex', result.selectIndex)
            if (inData.newDate > 0 && 
                (curCfg.config.selectIndex === 0 && result.selectIndex !== 0) ||
                (curCfg.config.selectIndex !== 0 && result.selectIndex === 0)) {
                onLoadData(inData, true)
            }
            else {
                onLoadData(inData, false)
            }
        }
    })
}

function setSignalChart(curChart, inData, chartName, region) {
    const chart = curChart.getChart(chartName)        
    {
        const cvname = chartName + 'market'
        const curRect = CLAPI.getChartRect(region, 1, 1, 0, 0)
        
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }, 
            },
            config: CLAPI.Utils.mergeObjectOfDeep(
                {
                    header : {
                        spaceY: 4, // Y方向留空     
                    },
                    autoexpand : true,
                    fieldlock  : 2,  // 按左键时，前面3个字段不动  
                    fieldmins  : 3,      
                    curKeyIdx  : 1,  // 用于检索curKey的字段索引
                }, CLAPI.ChartRes.CHART_TABLE),
            tableInfo : SPOOL.signalInfo,
            rectMain: curRect
        }
        const mclassname = getMclassName(inData)
        const curIndex = Init.getUserInfo(inData.modulename, mclassname + 'dateindex', 0)
        
        const curchart = chart.createChart(cvname, 'system.table', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            // if (result.event === 'headclick') {
            //     console.log(result);
            // }
            if (result.event === 'click') {
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
                changeLink(curChart, inData, result.curCode, chartName)
            }
            if (result.event === 'changeselect') {
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
                changeLink(curChart, inData, result.curCode, chartName)
            }
            if (result.event === 'dataclick') {
                // console.log(result, makets);
                result.key = 'Enter'
                result.code = 'Enter'
                result.keyCode = 13
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
                Init.sendKeydownEvent(result)
            }
        })
        chart.setlinkInfo('curKey', Init.getcurKey())
        chart.bindData(curchart, cvname)
    }

}

function setPShareChart(curChart, inData, chartName, region) {
    const chart = curChart.getChart(chartName)        
    {
        const cvname = chartName + 'market'
        const curRect = CLAPI.getChartRect(region, 1, 1, 0, 0)
        
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }, 
            },
            config: CLAPI.Utils.mergeObjectOfDeep(
                {
                    header : {
                        spaceY: 4, // Y方向留空     
                    },
                    autoexpand : true,
                    fieldlock  : 2,  // 按左键时，前面3个字段不动   
                    fieldmins  : 1,        
                    curKeyIdx  : 1,  // 用于检索curKey的字段索引
                }, CLAPI.ChartRes.CHART_TABLE),
            tableInfo : SPOOL.shareInfo,
            rectMain: curRect
        }
        const mclassname = getMclassName(inData)
        const curIndex = Init.getUserInfo(inData.modulename, mclassname + 'dateindex', 0)
        
        const curchart = chart.createChart(cvname, 'system.table', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            // if (result.event === 'headclick') {
            //     console.log(result);
            // }
            if (result.event === 'click') {
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
                changeLink(curChart, inData, result.curCode, chartName)
            }
            if (result.event === 'changeselect') {
                console.log(result);
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
                changeLink(curChart, inData, result.curCode, chartName)
            }
            if (result.event === 'dataclick') {
                // console.log(result, makets);
                result.key = 'Enter'
                result.code = 'Enter'
                result.keyCode = 13
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
                Init.sendKeydownEvent(result)
            }
        })
        chart.setlinkInfo('curKey', Init.getcurKey())
        chart.bindData(curchart, cvname)
    }

}
function changeLink(curChart, inData, curKey, chartName) {
    if (chartName === undefined || chartName === 'PGradeChart') {
        const psharechart = curChart.getUserChart('PShareChart', 'PShareChart' + 'market')
        const signalchart = curChart.getUserChart('SignalChart', 'SignalChart' + 'market')
        
        psharechart.changeSelectIndex(curKey)
        signalchart.changeSelectIndex(curKey)
    }
    else {
        const psharechart = curChart.getUserChart('PShareChart', 'PShareChart' + 'market')
        const signalchart = curChart.getUserChart('SignalChart', 'SignalChart' + 'market')
        const grade1chart = curChart.getUserChart('PGradeChart0', 'PGradeChart0' + 'market0')
        const grade2chart = curChart.getUserChart('PGradeChart1', 'PGradeChart1' + 'market1')
        const grade3chart = curChart.getUserChart('PGradeChart2', 'PGradeChart2' + 'market2')
        const grade4chart = curChart.getUserChart('PGradeChart3', 'PGradeChart3' + 'market3')
        if (chartName === 'PShareChart') {
            signalchart.changeSelectIndex(curKey)
        }
        if (chartName === 'SignalChart') {
            psharechart.changeSelectIndex(curKey)
        } 
        grade1chart.changeSelectIndex(curKey)
        grade2chart.changeSelectIndex(curKey)
        grade3chart.changeSelectIndex(curKey)
        grade4chart.changeSelectIndex(curKey)  
    }

    const mclassname = getMclassName(inData)
    Init.setUserInfo(inData.modulename, mclassname + 'nearKey', curKey)
                
}

function setPGradeChart(curChart, inData, region) {

    for (let grade = 0; grade < 4; grade++) {
        let chartName = 'PGradeChart' + String(grade)
        const chart = curChart.getChart(chartName)
        
        const cvname = chartName + 'market' + String(grade)
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, grade)    
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }, 
            },
            config: CLAPI.Utils.mergeObjectOfDeep(
                {
                    header : {
                        spaceY: 4, // Y方向留空     
                    },
                    autoexpand : true,
                    fieldlock  : 2,  // 按左键时，前面3个字段不动    
                    fieldmins  : 6,       
                    curKeyIdx  : 1,  // 用于检索curKey的字段索引
                }, CLAPI.ChartRes.CHART_TABLE),
            tableInfo : CLAPI.Utils.copyObjectOfDeep(SPOOL.gradeInfo),
            rectMain: curRect
        }
        const mclassname = getMclassName(inData)
        const curIndex = Init.getUserInfo(inData.modulename, mclassname + 'dateindex', 0)
        
        const curchart = chart.createChart(cvname, 'system.table', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            // if (result.event === 'headclick') {
            //     console.log(result);
            // }
            if (result.event === 'click') {
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
                changeLink(curChart, inData, result.curCode, 'PGradeChart')
            }
            if (result.event === 'changeselect') {
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
                changeLink(curChart, inData, result.curCode, 'PGradeChart')
            }
            if (result.event === 'dataclick') {
                // console.log(result, makets);
                result.key = 'Enter'
                result.code = 'Enter'
                result.keyCode = 13
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
                Init.sendKeydownEvent(result)
            }
        })
        chart.setlinkInfo('curKey', Init.getcurKey())
        chart.bindData(curchart, cvname)
    }

}

function setLinkChart(curChart, inData, chartName, region) {
    const chart = curChart.getChart(chartName)  
    
    {
        const cvname = chartName + 'link'
        const curRect = CLAPI.getChartRect(region, 1, 1, 0, 0)
        const curCfg = {
            config: {
                pixel : 16,
                font: 'sans-serif',
                label : region.label,
            },
            rectMain: curRect
        }
        chart.createChart(cvname, 'system.text', curCfg, function (result) { 
        })
    }
}

function readyPoolData(curChart, inData) {

    // 这里设置公共信息
    inData['KeyInfo'] = DATAS.mAinfoToKeyInfo(inData['ainfos'])
    
    {
        const chartName = 'SignalChart'
        const chart = curChart.getChart(chartName)  
        chart.setKeyInfo(inData['KeyInfo'])
        const cvname = chartName + 'market'
        const vdatas = SPOOL.GetAsignalTable(inData['asignal'], inData['KeyInfo'], inData.newpInfo)        
        chart.setData(cvname, vdatas)
    }
    {
        const chartName = 'PShareChart'
        const chart = curChart.getChart(chartName)  
        chart.setKeyInfo(inData['KeyInfo'])
        const cvname = chartName + 'market'
        const vdatas = SPOOL.GetPShareTable(inData['codeinfo'], inData['achip3'], inData['KeyInfo'], inData.newpInfo)        
        chart.setData(cvname, vdatas)
    }
    
    function readyGradeData(inData, vdatas, newbar) {
        
        for (let grade = 0; grade < 4; grade++) {
            const chartName = 'PGradeChart' + String(grade)
            const chart = curChart.getChart(chartName)  
            chart.setKeyInfo(inData['KeyInfo'])
            const cvname = chartName + 'market' + String(grade)
            const usechart = chart.chart.getChart(chartName + 'market' + String(grade))  
            
            console.log(vdatas[grade]);
            
            const wrate = SPOOL.SetPGradeTableNewp(vdatas[grade], newbar, inData.newpInfo)
            
            usechart.changeTlabel(6, wrate, true)
            console.log(wrate);
            
            chart.setData(cvname, vdatas[grade])

            usechart.onPaint()
        }
    }
    {
        const vdatas = []
        let codes = ''
        for (let grade = 0; grade < 4; grade++) {
            const curdata = SPOOL.GetPGradeTable(inData['codeinfo'], inData['achip3'], grade, inData['KeyInfo'], inData.newpInfo)
            if (codes.length > 1 && curdata.datas.length > 0) {
                codes += ','
            }
            if (curdata.datas.length > 0) {
                codes += DATAS.extractField(curdata, 'code')
            }
            vdatas.push(curdata)
        }
        console.log(codes, inData.newDate, inData.curDate);
        
        // 以下代码获取最新行情数据
        // if (inData.newDate > inData.curDate) {
        //         Init.sendCommand(
        //         {   
        //             cmds : {
        //                 "newbar": {
        //                     "cmd": "mc2p",
        //                     "subject": "getnewbar",
        //                     "service": "realtdx.py",
        //                     "info": codes
        //                 },
        //             }
        //         }, 
        //         function reply(datas) {
        //             // console.log(datas);
        //             if (Init.checkDatas(datas)) {
        //                 readyGradeData(inData, vdatas, datas['newbar'])
        //             }
        //         });
        // }
        // else 
        {
            readyGradeData(inData, vdatas)
        }
    }
}

// 画日线
function drawSignal(inData, isFirst) {

    console.log('Draw ====> Market Table')
    console.log(inData)
    
    const curChart = Init.getSysChart()
    if (isFirst) {
        // 设置为单一窗口 并返回第一个窗口
        curChart.initChart(['SignalChart', 'PShareChart', 'PGradeChart0', 'PGradeChart1', 'PGradeChart2', 'PGradeChart3', 'LinkChart1', 'LinkChart2', 'mclassCtrl', 'DateCtrl'])
        // 得到第一个窗口
        const canvas = Init.canvas
        
        const ctrlWidth = SPOOL.FWIDTH * Init.scale
        const clsHeight = 25 * Init.scale
        // 设置顶部窗口
        setMclassCtrl(curChart, inData, {
            style: 'sidebar',
            top: 0,
            left: 0,
            width: canvas.width,
            height: clsHeight,
        })
        // 设置左部窗口
        setDateCtrl(curChart, inData, {
            style: 'sidebar',
            top: clsHeight,
            left: 0,
            width: ctrlWidth - Init.scale,
            height: canvas.height - clsHeight,
        })
        const midWidth = 0 // 30 * Init.scale
        const winWidth = canvas.width - ctrlWidth - 2 * midWidth + 5 * Init.scale
        const winWidth2 = (winWidth) * 0.52
        const winWidth0 = (winWidth - winWidth2) * 0.52
        const winWidth1 = (winWidth - winWidth2 - winWidth0)
        let winLeft = ctrlWidth
        setSignalChart(curChart, inData, 'SignalChart', {
            style: 'average',
            top: clsHeight,
            left: winLeft,
            width: winWidth0 + Init.scale,
            height: canvas.height - clsHeight,
        })
        winLeft += winWidth0 + Init.scale
        if (midWidth > 0) {
            setLinkChart(curChart, inData, 'LinkChart1', {
                style: 'average',
                top: clsHeight,
                left: winLeft,
                label: '&',
                width: midWidth + Init.scale,
                height: canvas.height - clsHeight,
            })
            winLeft += midWidth + Init.scale
        }
        setPShareChart(curChart, inData, 'PShareChart', {
            style: 'average',
            top: clsHeight,
            left: winLeft,
            width: winWidth1 + Init.scale,
            height: canvas.height - clsHeight,
        })
        winLeft += winWidth1 + Init.scale
        if (midWidth > 0) {
            setLinkChart(curChart, inData, 'LinkChart2', {
                style: 'average',
                top: clsHeight,
                left: winLeft,
                label: '=',
                width: midWidth + Init.scale,
                height: canvas.height - clsHeight,
            })
            winLeft += midWidth + Init.scale
        }
        setPGradeChart(curChart, inData, {
            style: 'average',
            top: clsHeight,
            left: winLeft,
            width: winWidth2 + Init.scale,
            height: canvas.height - clsHeight,
        })
    }

    readyPoolData(curChart, inData)

    curChart.onPaint()

    const mclassname = getMclassName(inData)
    const curKey = Init.getUserInfo(inData.modulename, mclassname + 'nearKey')
    if (curKey) {
        changeLink(curChart, inData, curKey)
    }
}

function onLoadData(inData, isFirst) {

    const mclassname = getMclassName(inData)
    
    const curIndex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'dateindex', 0), inData['dates'].datas.length)
    
    let curDate = CLAPI.getData(inData['dates'], 'date', curIndex)
    // console.log(inData, curDate);
    
    if (curDate == inData.newDate && inData.newDate > inData.curDate) {
        curDate = inData.curDate
    }
            
    Init.sendCommand(
        {   
            cmds : {
                "asignal" : { "cmd" : "get", "subject" : "CN000000.db_ssumm", "service": "signal/" + mclassname, "info" : {"sub-date" : curDate}},
                "achip3" : { "cmd" : "get", "subject" : "CN000000.chip3_date", "service": "atdb/chip3", "info" : {"sub-date" : curDate, "fields" : SPOOL.chip3_fields}}
            }
        },
        
        function reply(datas) {
            console.log(datas);
            if (Init.checkDatas(datas)) {
                inData['achip3'] = datas['achip3']
                inData['codeinfo'] = SPOOL.mergeAsignal(inData['nsignal'], datas['asignal'], inData.newpInfo)
                inData['asignal']  = SPOOL.codeinfoToAsignal(inData['codeinfo'], inData.newpInfo)
                drawSignal(inData, isFirst)
            }
        });
}

function onLoadInitInfo(inData) 
{
    const mclassname = getMclassName(inData)
    function makeNsignal(inData)
    {
        let nowMsec = 0
        if (inData['nsignal']) {
            if (inData['nsignal']['infos'] && inData['nsignal']['infos'].length > 0) {
                const nowInfo = inData['nsignal']['infos'][0];
                nowMsec = CLAPI.Utils.strMsecToMTime(nowInfo.msecstamp)
            }  
        }
        // console.log(nowInfo, nowMsec);
        let nowDate = 0
        if (nowMsec > 0) {
            nowDate = CLAPI.Utils.getMsecDate(nowMsec)
            if (nowDate > 0) {
                // 增加索引
                inData['dates'].datas.unshift([nowDate])
            }
        }
        return nowDate === 0 ? CLAPI.Utils.getNowDate() : nowDate
    }

    const nowDate = CLAPI.Utils.getNowDate()
    inData.curDate = CLAPI.getData(inData['dates'], 'date', 0)
    
    Init.sendCommand(
    {   
        cmds : {
            "ainfos"  : { "cmd" : "get", "subject" : "CN000000.alpha_info", "service": "atdb/minu1", "info" : { "sub-date" : inData.curDate}},
            "ninfos"  : { "cmd" : "get", "subject" : "CN000000.alpha_stopinfo", "service": "atdb/minu1", "info" : { "sub-date" : inData.curDate, "fields" : 'msec,code,newprc'}},
            "nsignal" : { "cmd" : "redis", "subject" : "signal", "service": '47.242.109.110:17329', "info" : {"command" : "lrange " + mclassname + ":" + nowDate + " 0 -1"}},
        }
    },
    function reply(datas) {
        if (Init.checkDatas(datas, ['nsignal'])) {
            inData['ainfos']  = datas['ainfos']
            inData['ninfos']  = datas['ninfos']
            inData['nsignal'] = datas['nsignal']
            // 下面设置当前的公共信息
            inData.newpInfo = DATAS.stopInfoSetNewp(datas['ninfos'], inData.newpInfo, datas['ainfos'])
            inData.newDate = makeNsignal(inData)
            // console.log(inData);
            
            onLoadData(inData, true)
        }
    });
}
export function onLoad(argvs) {
    let inData = {}
    if (argvs) {
        inData.modulename = argvs.modulename ?? 'normal'
        inData.modulepath = argvs.modulepath ?? inData.modulename
    }
    else {
        inData.modulename = 'spool3'
    }
    
    SPOOL.onInit()

    Init.sendCommand(
        {   
            cmds : {
                "dates"   : { "cmd" : "get", "subject" : "SH000001.alpha_info", "service": "merge/ainfo", "info" : {"offset" : -60, "fields" : 'msec'}}
            }
        },
        function reply(datas) {
            // console.log(datas)
            if (Init.checkDatas(datas)) {
                inData['dates'] = DATAS.swapDatefromMsec(datas['dates'], 'msec')
                onLoadInitInfo(inData)
            }
        });
}


// 注册方法到参数表
